The response from the `createCandidateProcessHistoryItem` mutation.
